<template>
  <div>
    Settings
  </div>
</template>

<script>

export default {
  name: 'Orders',

  components: {
  },
};
</script>
